import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/ai-capability-center/voice-creation',
  name: 'aiVoiceCreation',
  component: Layout,
  redirect: '/ai-capability-center/voice-creation/physician-voices',
  meta: {
    title: '语音工作台',
    icon: 'i-lucide:audio-lines',
  },
  children: [
    {
      path: 'physician-voices',
      name: 'aiPhysicianVoices',
      component: () => import('@/views/ai_capability_center/voice_creation/physician-voices.vue'),
      meta: {
        title: '医师音色库',
        icon: 'i-lucide:mic-vocal',
      },
    },
    {
      path: 'podcast-creation',
      name: 'aiPodcastCreation',
      component: () => import('@/views/ai_capability_center/voice_creation/podcast-creation.vue'),
      meta: {
        title: '播客制作台',
        icon: 'i-lucide:podcast',
      },
    },
    {
      path: 'podcast-creation/production',
      name: 'aiPodcastProduction',
      component: () => import('@/views/ai_capability_center/voice_creation/podcast-production.vue'),
      meta: {
        title: '制作播客',
        menu: false,
        activeMenu: '/ai-capability-center/voice-creation/podcast-creation',
      },
    },
  ],
}

export default routes
